export default __webpack_public_path__ + "static/media/customer-ruby.b9db186e.jpg";